<script lang="ts">
  import type { Snippet } from 'svelte'
  import type { HTMLAttributes } from 'svelte/elements'

  type Props = HTMLAttributes<HTMLDivElement> & {
    children: Snippet
  }

  const { children, class: className, ...rest }: Props = $props()
</script>

<div
  class={`container ${className}`}
  {...rest}
>
  {@render children()}
</div>

<style lang="scss">
  .container {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
</style>
